$(() => {
    const $applyBar = $('.job-detail-floating-apply-bar');
    const $jobCard = $('.job-card-v4');

    $applyBar.hide();

    $('.cobrand-footer').addClass('footer-padding');

    $(window).on('scroll', function() {
        const jobCardPosition = $jobCard.offset().top + $jobCard.outerHeight();
        const scrollPosition = $(window).scrollTop();

        if (scrollPosition > jobCardPosition) {
            $applyBar.fadeIn();
        } else {
            $applyBar.fadeOut();
        }
    });
});
